export const API_URL =
  window.location.href.indexOf("localhost") >= 0
    ? ""
    : "https://main.rimeim.com/api";

export const APP_NAVBAR_COLOR = "background-color-rimeim";
